import styled from "styled-components";
import {defaultTheme} from "../../styles/themes/default";

const statuses = {
    danger: {color: defaultTheme.red},
    warning: {color: defaultTheme.yellow},
    success: {color: defaultTheme.green},
    normal: {color: defaultTheme.gray}
}

interface InputTextContainerProps {
    status: 'danger' | 'warning' | 'success' | 'normal'
}

export const InputTextContainer = styled.div<InputTextContainerProps>`
  width: 100%;

  label {
    display: block;
    font-style: normal;
    font-weight: 700;
    font-size: 12px;
    //line-height: 14px;
    letter-spacing: 0.3px;
    text-transform: uppercase;
    color: ${({theme}) => theme.gray};
    transition: all 300ms ease;

    :focus-within {
      color: ${({theme}) => theme.accent};
    }
  }

  input {
    width: 100%;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: ${({theme}) => theme.black};
    padding: 11px 16px;
    border-radius: 8px;
    background: ${({theme}) => theme.grayExtraLight};
    border: 1px solid ${({status}: InputTextContainerProps) => statuses[status].color};
    transition: all 300ms ease-in-out;
    margin-top: 6px;

    ::placeholder {
      color: ${({theme}) => theme.gray};
      opacity: 0.4;
    }

    :focus {
      border-color: ${({status}: InputTextContainerProps) => status === 'normal' ? defaultTheme.accent : statuses[status].color};
    }

    :disabled {
      border: unset;
      background: ${({theme}) => theme.grayLightest};
      opacity: 0.4;
    }
  }

  small {
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    letter-spacing: 0.1px;
    text-align: left;
    margin-top: 10px;
    color: ${({status}: InputTextContainerProps) => statuses[status].color};
  }
`

export const LabelHeader = styled.div`
  display: flex;
  align-items: center;
`
